import { useState } from "react";
import apiConfig from "../config/apiConfig";
import { toast } from "../utils/toast";
import "./Dashboard.css";
import { Loader } from "lucide-react";
import { getConfig } from "../config/runtimeConfig";

declare global {
    interface Window {
        Razorpay: any;
    }
}

const PaymentIciciInitiate = ({
    programme,
    roundName,
    selectedAppToAccept,
    onClose,
    roundFee,
    slot
}: {
    programme: string
    roundName: string
    selectedAppToAccept: any
    onClose: () => void
    roundFee: number
    slot: number
}) => {

    const [loading, setLoading] = useState(false);
    const [showGatewaySelection, setShowGatewaySelection] = useState(false)
    const [selectedGateway, setSelectedGateway] = useState<string | null>(null)

    const handleIciciAcceptOffer = async (app: any) => {
        try {
            setLoading(true);

            const res = await fetch(
                `${apiConfig.API_BASE_URL}/payment/icici/initiate?amount=${roundFee}&refNo=${app?.application_number}&programme=${programme}&slot=${slot}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                }
            );

            const data = await res.json();

            if (res?.ok && data.success === "true") {
                window.location.href = data.paymentUrl;
            } else {
                console.log("Payment initiation failed.", data.message || "Payment failed");
                toast.error("Payment initiation failed. Please try again.");
            }

            console.log("firstfirst", data)

        } catch (err) {
            console.error(err);
            toast.error("Payment initiation failed. Please try again.");
        } finally {
            setLoading(false);
        }

        onClose()
    };

    const handleRazorpayAcceptOffer = async (app: any) => {

        try {
            setLoading(true);

            const stored = localStorage.getItem("user");
            const user = JSON.parse(stored || "{}");

            if (!user?.userId) {
                toast.error("User session not found. Please login again.");
                return;
            }

            let appId = "";
            if (app && app.id) {
                appId = app.id;
            } else {
                toast.error("Application data not found for current drive.");
                return;
            }


            const internalOrderId = "ORD_" + Date.now();

            // ✅ Call backend to create Razorpay order
            const res = await fetch(
                `${apiConfig.API_BASE_URL}/payments/initiate/razorpay?appId=${appId}&round=true`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        internalOrderId,
                        amount: roundFee,
                        currency: "INR",
                        programme: programme,
                        slot: slot
                    }),
                    credentials: "include",
                }
            );

            if (!res.ok) {
                throw new Error("Order creation failed");
            }

            const data = await res.json();

            // ✅ Razorpay configuration
            const options = {
                key: data.key,
                amount: data.amount,
                currency: data.currency || "INR",
                order_id: data.gatewayOrderId,

                name: "IIIT Bangalore",
                description: "Round Fee",

                handler: function () {
                    window.location.href = `/payment-status?orderId=${internalOrderId}&round=true`;
                },

                modal: {
                    ondismiss: function () {
                        window.location.href = `/payment-status?orderId=${internalOrderId}&round=true`;
                    },
                },
            };

            if (!window.Razorpay) {
                throw new Error("Razorpay SDK not loaded.");
            }

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (err) {
            console.error(err);
            toast.error("Payment initiation failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    const handleShowGateway = async () => {
        setShowGatewaySelection(true)
    }

    const handleAceptOffer = async (app: any) => {
        if (selectedGateway === "ICICI") {
            handleIciciAcceptOffer(app)
        }
        else if (selectedGateway === "RAZORPAY") {
            handleRazorpayAcceptOffer(app)
        }
    }

    return (
        <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001
        }}>
            <div className="modal-content" style={{
                backgroundColor: '#fff',
                padding: '24px',
                borderRadius: '8px',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif'
            }}>
                {loading ?
                    <div style={{
                        display: "flex",
                        justifyContent: "center"
                    }}>
                        <Loader size={20} />
                    </div> :
                    <>
                        {!showGatewaySelection ?
                            <div>
                                <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '1.25rem', color: '#111827', fontWeight: 600 }}>
                                    {'Confirm Acceptance'}
                                </h3>
                                <div style={{ marginBottom: '24px', color: '#374151', lineHeight: '1.6', fontSize: '16px' }}>
                                    {(
                                        <>
                                            <p>Are you sure you want to <strong>ACCEPT</strong> the offer for <strong>{(programme)?.replace(/_/g, " ")}</strong> for <strong>{(roundName)?.trim()}</strong>?</p>
                                            <div className="alert alert-info py-2 px-3 mt-3" style={{ fontSize: '14px', borderRadius: '8px', backgroundColor: '#e0f2fe', border: '1px solid #bae6fd', color: '#0369a1' }}>
                                                <strong>Note:</strong> To complete the acceptance, you will need to pay the fees. Clicking the button below will proceed to the payment.
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                    <button
                                        onClick={onClose}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#f3f4f6',
                                            color: '#4b5563',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '6px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {'Close'}
                                    </button>
                                    {(
                                        <button
                                            onClick={() => handleShowGateway()}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: '#54ad58',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Pay Fee & Accept Offer
                                        </button>
                                    )}
                                </div>
                            </div> :
                            <div>
                                <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '1.25rem', color: '#111827', fontWeight: 600 }}>
                                    {'Choose Payment Gateway'}
                                </h3>
                                <div style={{ marginBottom: '24px', color: '#374151', lineHeight: '1.6', fontSize: '16px' }}>
                                    {(
                                        <>
                                            <p>Select either of the payment gateway to proceed with the payment </p>
                                        </>
                                    )}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly', gap: '12px' }}>
                                    {/* <button
                                        onClick={() => setSelectedGateway("ICICI")}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: selectedGateway === "ICICI" ? '#e0f2fe' : '#f3f4f6',
                                            color: selectedGateway === "ICICI" ? '#0369a1' : "#4b5563",
                                            border: selectedGateway === "ICICI" ? '2px solid #bae6fd' : '1px solid #d1d5db',
                                            borderRadius: '6px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {'ICICI'}
                                    </button> */}

                                    <button
                                        onClick={() => setSelectedGateway("RAZORPAY")}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: selectedGateway === "RAZORPAY" ? '#e0f2fe' : '#f3f4f6',
                                            color: selectedGateway === "RAZORPAY" ? '#0369a1' : "#4b5563",
                                            border: selectedGateway === "RAZORPAY" ? '2px solid #bae6fd' : '1px solid #d1d5db',
                                            borderRadius: '6px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {'Razorpay'}
                                    </button>
                                </div>
                                {(selectedGateway === "ICICI" || selectedGateway === "RAZORPAY") && <>
                                    <div style={{ marginBottom: '24px', color: '#374151', lineHeight: '1.6', fontSize: '16px' }}>
                                        <div className="alert alert-info py-2 px-3 mt-3" style={{ fontSize: '14px', borderRadius: '8px', backgroundColor: '#e0f2fe', border: '1px solid #bae6fd', color: '#0369a1' }}>
                                            <strong>Note:</strong> Clicking the button below will proceed to the respective payment gateway.
                                        </div>
                                    </div>
                                    {(
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                            <button
                                                onClick={onClose}
                                                style={{
                                                    padding: '8px 16px',
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#4b5563',
                                                    border: '1px solid #d1d5db',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {'Close'}
                                            </button>
                                            <button
                                                onClick={() => handleAceptOffer(selectedAppToAccept)}
                                                style={{
                                                    padding: '8px 16px',
                                                    backgroundColor: '#54ad58',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                Proceed to Payment Gateway
                                            </button>
                                        </div>
                                    )}
                                </>}
                            </div>}

                    </>
                }
            </div>
        </div >
    );
};

export default PaymentIciciInitiate;
